import { Divider, styled } from '@mui/material'

export const ActionsBoxContainer = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(3),
}))

export const ConfigDivider = styled(Divider)({
  margin: '1rem -24px',
})
